import EPubFormContainer from './EPubFormContainer';
import EPubUpload from './service/EPubUpload';
import stores from './stores';

const ePubForm = {
  path: ['/add-epub'],
  exact: true,
  services: [new EPubUpload()],
  stores: stores,
  component: EPubFormContainer,
};

export default ePubForm;
